import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createToggleCheckAllRecordsAction, getCheckedRecords, getRecords, isCheckedAll, isEmpty } from "@multiweb/reactCore/datasource";
import { getRootNodes } from "@multiweb/reactCore/workflow";
import { IAppState } from "@multiweb/types/react";
import { WFParticipantsDialogComponent, WFParticipantsDialogComponentProps } from "../WFParticipantsDialogComponent";

export type WFParticipantsDialogProps = {
    /** Unikátní klíč pro DataSource. */
    readonly dataSourceKey: string;
};

type StateProps = Pick<WFParticipantsDialogComponentProps, "allRecordsChecked" | "rootParticipants" | "participantRecords" | "participantsSelection" | "isEmpty">;

const mapStateToProps: MapStateToProps<StateProps, WFParticipantsDialogProps, IAppState> = (state, { dataSourceKey }) => ({
    allRecordsChecked: isCheckedAll(state, dataSourceKey),
    rootParticipants: getRootNodes(state, dataSourceKey),
    participantRecords: getRecords(state, dataSourceKey),
    participantsSelection: getCheckedRecords(state, dataSourceKey),
    isEmpty: isEmpty(state, dataSourceKey) ?? true,
});

type DispatchProps = Pick<WFParticipantsDialogComponentProps, "toggleCheckAllRecords">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, WFParticipantsDialogProps> = (
    dispatch,
    { dataSourceKey },
) => ({
    toggleCheckAllRecords: () => dispatch(createToggleCheckAllRecordsAction(dataSourceKey)),
});

export const WFParticipantsDialog = connect(
    mapStateToProps, mapDispatchToProps,
)(WFParticipantsDialogComponent);
